import { get } from '../base/index';

export default {
    getGeneralStatistics: () => {
        return get(`${process.env.REACT_APP_URL_BASE}/statistics-general/`)
    },
    getStatisticsUserRegister: (params) => {
        return get(`${process.env.REACT_APP_URL_BASE}/statistics-user-register/?start_date=${params.start_date}&end_date=${params.end_date}`)
    }
}